export const getUnitIconClassNameForButton = (unitTypeId) => {
  const specialStyles = {
    unit_d4: 'new-units-toolbar_unit-img-d4-d6',
    unit_d6: 'new-units-toolbar_unit-img-d4-d6'
  }
  return specialStyles[unitTypeId] || `new-units-toolbar_unit-img`;
}